import MasterTrackerDetail from './MasterTrackerDetail';
import UIBox from '../UIBox';
import TrackerList from './TrackerList';
import { Box, Stack } from '@mui/material';
import { trackerSx } from '../sxStyles/Datatable/deviceTableList';

export default function Tracker() {
  return (
    <UIBox header={'Master Tracker Detail'}>
      <Box sx={trackerSx.detailWrapper}>
        <Stack spacing={2}>
          <MasterTrackerDetail />
          <TrackerList />
        </Stack>
      </Box>
    </UIBox>
  );
}
